import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import Box from '@mui/material/Box';
import { Text } from 'components/Text';
import { IMAGES } from 'config/images';
import { Layout } from 'modules/minimal-ui-theme';

/**
 * Informational counterpart to `ErrorScreen` for guest outcomes that are NOT failures.
 *
 * `missing-token` is the case that needs it: the copy is already reassuring ("your session
 * needs the original link… continue right where you left off"), but routing it through
 * `ErrorScreen` wrapped that in the error illustration, so a recoverable, expected state
 * read as "something broke and your CV is gone". Nothing is lost — the CV is saved
 * server-side and reopening the emailed link resumes it — so the treatment should say so.
 */
export const GuestInfoScreen = ({
  title,
  description1,
  description2
}: {
  title: string;
  description1: string;
  description2: string;
}) => (
  <Layout
    childrenStyles={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      minHeight: '80vh',
      gap: 2
    }}
  >
    <img
      alt="Zenjob Pro Logo Purple"
      src={IMAGES.proLogoPurple}
      style={{ maxWidth: '30vw', maxHeight: '7vh' }}
    />
    <MarkEmailReadOutlinedIcon sx={{ fontSize: 48, color: 'primary.main' }} />
    <Box
      sx={{
        maxWidth: 460,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1
      }}
    >
      <Text variant="h4">{title}</Text>
      <Text>{description1}</Text>
      <Text>{description2}</Text>
    </Box>
  </Layout>
);
